import{classAdderBuilder as d}from"../../common/dist/classadder/classAdderBuilder.js";d({class:"mdc-deprecated-list-group",tag:"div"});
//# sourceMappingURL=Group.js.map
